/**
 * 屏幕旋转
 * @author libaoxu@gaosiedu.com
 * @date 2016-11-1
 */

export default {
  name: 'orientation-change',

  /**
   * 屏幕旋转定时器
   */
  orientationChangedTimeout: null,

  /**
   * 上一次屏幕旋转的值
   */
  lastOrientation: null,

  bind() {

    this.orientationChangeBindFunc = this.orientationChangeHandler.bind(this);

    window.addEventListener('orientationchange', this.orientationChangeBindFunc);

  },

  // 空函数
  noop: function () {

  },

  update(handlerFunc) {
    if (typeof handlerFunc === 'function') {
      this.handlerFunc = handlerFunc.bind(this.vm);
    } else if (typeof this.vm.orientationChange === 'function') {
      this.handlerFunc = this.vm.orientationChange.bind(this.vm);
    } else {
      this.handlerFunc = this.noop;
    }

  },

  unbind() {
    // 定时器也清除
    clearTimeout(this.orientationChangedTimeout);
    // 移除事件
    window.removeEventListener('orientationchange', this.orientationChangeBindFunc);
  },

  /**
   * window 监听 orientationChange 滚动事件
   *  注意: this指向不是window, 是Vue.directive(string, definition)的第二个参数: definition
   */
  orientationChangeHandler(e) {

    /**
     * 因为部分手机获取屏幕宽度有延迟
     */
    if (window.orientation != undefined && !window.innerWidth) {
      clearTimeout(this.orientationChangedTimeout);

      this.orientationChangedTimeout = setTimeout(() => {
        // alert(window.innerWidth)
        let ori = window.orientation;

        if (ori != this.lastOrientation) {
          // 这里才是真正执行回调函数  
          this.handlerFunc(e);
        }

        this.lastOrientation = ori;

      }, 300);

    } else {
      this.handlerFunc(e);
    }

  }
}